<div class="container">
    <!-- <div class="actions">
        <button (click)="addVehicle()" class="btn-action">
            <fa-icon [icon]="['fas', 'square-plus']" class="fa-thin"></fa-icon>
            Add Vehicle</button>
        <button (click)="bulkUpload()" class="btn-action">
            <fa-icon [icon]="['fas', 'upload']" class="fa-solid"></fa-icon>
            Bulk Upload</button>
    </div> -->

    <div class="container-table">
        <header class="top-header">
            <h3>Alert Records</h3>
            <p>Vehicle Details As On {{todayDate | reportingDate:'date' }}</p>
        </header>

        <div>
            <app-shared-table-toolbar>
                <!-- alerts-compact-search: Issue #43 — leave room for up to 3 filters + Export on one desktop row -->
                <div toolbarSearch class="search-bar alerts-compact-search">
                    <app-generic-search [apiUrl]="'vehicle-alerts/search_suggestion'" [resultsApiUrl]="'vehicle-alerts/'"
                        [method]="'GET'" [searchParamName]="'q'" [pageSize]="10" [minChars]="2"
                                        [extraBody]="searchExtraBody"
                        (resultsFetched)="onResults($event)">
                    </app-generic-search>
                </div>
                <div toolbarFilters class="filters table-filters alerts-toolbar-filters">
                    <div class="filter">
                        <label>Date Range</label>
                        <select [(ngModel)]="dateFilter" (change)="applyFilters()">
                            <option value="">All</option>
                            <option *ngFor="let opt of dateOptions" [value]="opt.value">{{ opt.label }}</option>
                        </select>
                    </div>
                    <div class="filter">
                        <label>Alert Type</label>
                        <select [(ngModel)]="alertType" (change)="applyFilters()">
                            <option value="">All</option>
                            <option *ngFor="let type of alertTypeOptions" [value]="type.value">{{ type.label }}</option>
                        </select>
                    </div>
                    <div class="filter" *ngIf="showMonitoringTypeFilter">
                        <label>Monitoring Type</label>
                        <app-monitoring-type-multiselect
                                [selectedValues]="selectedMonitoringTypes"
                                (selectionApplied)="applyMonitoringTypeFilter($event)">
                        </app-monitoring-type-multiselect>
                    </div>
                </div>
                <button toolbarTrailing type="button" (click)="exportToExcel()" class="export-button">
                    <fa-icon [icon]="['fas', 'file-excel']" class="fa-thin"
                        style="color: white;font-size: 15px;"></fa-icon>
                    EXPORT EXCEL
                </button>
            </app-shared-table-toolbar>
            <div class="responsive-table-wrapper">
                <table>
                    <thead>
                        <tr>
                            <th>S.No</th>
                            <th class="sortable-header" (click)="sortData('vehicle_number')">
                                Vehicle No
                                <span class="sort-indicator">
                <fa-icon *ngIf="sortColumn === 'vehicle_number' && sortDirection === 'desc'"
                         [icon]="['fas', 'arrow-down']"></fa-icon>
                <fa-icon *ngIf="sortColumn === 'vehicle_number' && sortDirection === 'asc'"
                         [icon]="['fas', 'arrow-up']"></fa-icon>
              </span>
                            </th>
                            <th class="sortable-header" (click)="sortData('created_at')">
                                Created On
                                <span class="sort-indicator">
                <fa-icon *ngIf="sortColumn === 'created_at' && sortDirection === 'desc'"
                         [icon]="['fas', 'arrow-down']"></fa-icon>
                <fa-icon *ngIf="sortColumn === 'created_at' && sortDirection === 'asc'"
                         [icon]="['fas', 'arrow-up']"></fa-icon>
              </span>
                            </th>
                            <th class="sortable-header" (click)="sortData('alert_type')">
                                Alert Type
                                <span class="sort-indicator">
                <fa-icon *ngIf="sortColumn === 'alert_type' && sortDirection === 'desc'"
                         [icon]="['fas', 'arrow-down']"></fa-icon>
                <fa-icon *ngIf="sortColumn === 'alert_type' && sortDirection === 'asc'"
                         [icon]="['fas', 'arrow-up']"></fa-icon>
              </span>
                            </th>
                            <th>Monitoring Type</th>
                            <th class="sortable-header" (click)="sortData('direction')">
                                Direction
                                <span class="sort-indicator">
                <fa-icon *ngIf="sortColumn === 'direction' && sortDirection === 'desc'"
                         [icon]="['fas', 'arrow-down']"></fa-icon>
                <fa-icon *ngIf="sortColumn === 'direction' && sortDirection === 'asc'"
                         [icon]="['fas', 'arrow-up']"></fa-icon>
              </span>
                            </th>
                            <th>Message</th>
                            <th>Received by</th>
                            <th class="sortable-header" (click)="sortData('delivery_channel')">
                                Notification Channel
                                <span class="sort-indicator">
                <fa-icon *ngIf="sortColumn === 'delivery_channel' && sortDirection === 'desc'"
                         [icon]="['fas', 'arrow-down']"></fa-icon>
                <fa-icon *ngIf="sortColumn === 'delivery_channel' && sortDirection === 'asc'"
                         [icon]="['fas', 'arrow-up']"></fa-icon>
              </span>
                            </th>
                            <th class="sortable-header" (click)="sortData('status')">
                                Status
                                <span class="sort-indicator">
                <fa-icon *ngIf="sortColumn === 'status' && sortDirection === 'desc'"
                         [icon]="['fas', 'arrow-down']"></fa-icon>
                <fa-icon *ngIf="sortColumn === 'status' && sortDirection === 'asc'"
                         [icon]="['fas', 'arrow-up']"></fa-icon>
              </span>
                            </th>
                           
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let record of alertData let i = index ">
                            <td>{{ i + 1 + (currentPage - 1) * recordsPerPage }}</td>
                            <td [appVehicleNumberCopy]="record.vehicle_number">{{ record.vehicle_number }}</td>
                            <td>{{ record.created_at | reportingDate }}</td>
                            <td>
                                <app-alert-type-badge [alertType]="record.alert_type"></app-alert-type-badge>
                            </td>
                            <td>
                                <div class="monitoring-type-badges"
                                     *ngIf="record.alert_type === 'VEH_ALERT'; else noMonitoringTypes">
                                    <app-monitoring-type-badge
                                            *ngFor="let monitoringType of monitoringTypeCodes(record)"
                                            [monitoringType]="monitoringType">
                                    </app-monitoring-type-badge>
                                    <span *ngIf="!monitoringTypeCodes(record).length">-</span>
                                </div>
                                <ng-template #noMonitoringTypes>-</ng-template>
                            </td>
                            <td>{{ record.direction }}</td>
                            <td>{{ record.message }}</td>
                            <td>{{ record.received_by }}</td>
                            <td>{{ record.delivery_channel}}</td>
                            <td>{{ record.status}}</td>
                        </tr>
                    </tbody>
                </table>

                <div class="footer">
                    <div class="total-records">Total Records: {{ totalRecords }}</div>
                    <app-vte-pagination
                            [currentPage]="currentPage"
                            [pageSize]="recordsPerPage"
                            [totalRecords]="totalRecords"
                            [showJumpToPage]="true"
                            (pageChange)="onPageChange($event)"
                            (pageSizeChange)="onPageSizeChange($event)">
                    </app-vte-pagination>
                </div>
            </div>
        </div>
    </div>
</div>